/*jshint esversion: 6 */
import Vue from 'vue';
let lg_fmt = (l) => l.replace(/[ ()-]/gim, ''); // format login

let auth_store = {
    state: {
        auth_success: false
    },
    mutations: {
        authFailed(state) {
            state.auth_success = false;
        },
        authSuccess(state, context) {
            state.auth_success = true;
        },
        signOut(state) {
            console.log('EXIT ACTION');
            state.auth_success = false;
        }
    },
    actions: {
        startSignUp() {}
    }
};


export default {
    name: "auth",
    props: {
        "config": {
            type: Object,
            default: {
                logo: "http://app.landos.kz/assets/img/logo.png",
                background: "http://app.landos.kz/signin/img/bg.jpg",
                signup: true,
                password_reset: true,
                fast_signin: true
            }
        },
        "m": String
    },
    beforeMount() {
        //console.log(this.$route.path);
        this.$store.registerModule('auth', auth_store);
    },
    watch: {
        '$route'(to, from) {
            if(to.path === '/exit'){
                this.signOut();
                this.$router.push('/')
            }
        }
    },

    mounted() {
        this.$http.post('auth/check_session').then((res) => {
            if (res.body.auth) {
                this.$store.commit('authSuccess', res.body.user);
                this.$emit('auth-success', res.body.user);
            }
        });
    },
    computed: {
        allowSignIn() {
            return true;
        },
        allowSignUp() {
            return true;
        },
        allowResetPassword() {
            return true;
        },
        allowFastSignIn() {
            return true;
        },
        auth() {
            return this.$store.state.auth;
        }

    },
    methods: {
        codeConfirm() {
            let {login, code} = this;
            login = lg_fmt(login);
            this.$http.ipost('auth/signup_confirm', {
                login,
                code
            }).then((res) => {
                alert("Вы успешно зарегистрировались");
                //.then(() => {
                this.$http.get("fetch_all").then((res2) => {
                    this.$store.commit('authSuccess', res.user);
                    this.$store.commit('fetchAll', res2.body);
                    this.$store.commit('firstStart');
                });
            // });
            });
        },
        codeChange(e) {
            this.code = e.target.value;
            if (this.code.length === 6) {
                this.codeConfirm();
            } else {
                return alert('Неверный код');
            }
        },
/*        signIn(state, context) {
            let {login, password} = context;
            login = lg_fmt(login);
            localStorage.login = login;
            localStorage.password = password;
            return this.$http.ipost("auth/signin", {
                login,
                passwordRepeat
            }).then((res)=>{
                console.log(res)
            });
        },*/
        signUp(state) {
            let {login, password, passwordRepeat, agree = true} = this;
            login = lg_fmt(login);

            if (password != passwordRepeat) return alert('Введенные пароли не совпадают');
            if (!agree) return alert('Вы должны принять пользовательское соглашение');

            this.$http.ipost('auth/is_busy', {
                login
            }).then(() => {
                alert(`Сейчас на номер ${login} придет СМС сообщение, и откроется поле ввода. Введите код из СМС чтобы продолжить регистрацию`);

                this.$http.ipost("auth/signup", {
                    login,
                    password
                }).then((res) => {
                    let code = false, tries = 0, self = this;
                    function prompt_code(){
                        code = prompt('Введите код из СМС');
                        if (code === null) return alert('Отмена ввода');
                        
                        self.$http.ipost('auth/signup_confirm', {
                            login,
                            code
                        }).then((res) => {
                            alert("Вы успешно зарегистрировались");
                            tries = 0;
                            self.$store.commit('authSuccess', res.user);
                        }, ()=>{
                            tries++;
                            if(tries < 3){
                                prompt_code();
                            } else {
                                alert("Слишком много попыток");
                            }
                        });
                    }
                    prompt_code();
                //
                });
            //});
            });
        },
        fastSignIn() {},

        confirmPasswordReset() {
            let {login, password, code} = context;
            login = lg_fmt(login);
            this.$http.ipost("auth/password/set", {
                login,
                password,
                code
            }).then((res) => {
                alert('Пароль успешно сброшен. Можете использовать новый пароль для входа');
            });
        },
        resetPassword() {
            let self = this;
            let {login, password} = this;
            return this.$http.ipost("auth/password/reset_phone", {login}).then((res) => {
                let code = prompt("Введите код из СМС");
                this.$http.ipost("auth/password/set_with_phone", { phone:login, password, code}).then((res) => {
                    alert('Пароль успешно сброшен. Можете использовать новый пароль для входа');
                });
             });
        },
        startSignUp() {
            this.signUpFormShow = true;
        },

        signIn() {
            let {login, password} = this;

            localStorage.login = login;
            localStorage.password = password;
            this.wip = true;
            this.$http
                .ipost("auth/signin", {
                    login: login.replace(/[ ()-]/gim, ''),
                    password
                })
                .then((res) => {
                    this.$store.commit('authSuccess', res.user);
                    this.$emit('auth-success', res.user);
                }, () => {
                    //this.wip = false;
                });
        },
        signOut() {
            this.$http.ipost("auth/signout").then((res) => {
                this.$store.commit('signOut');
            });

        },
        fastSignIn() {},
        confirmPasswordReset() {
            let self = this;
            let {login, password, code} = this;
            this.$http.ipost("auth/password/set_with_phone", {
                phone: login,
                password,
                code
            }).then((res) => {
                alert('Пароль успешно сброшен. Можете использовать новый пароль для входа');
                self.passwordResetCodeModalOpened = false;
            });
        },
        /*resetPassword() {
            let self = this;
            let {login} = this;
            this.$http.ipost("auth/password/reset_phone", {
                phone: login
            }).then((res) => {
                self.passwordResetModalOpened = false;
                self.passwordResetCodeModalOpened = true;
            });
        }*/
    },
    data() {
        return {
            login: localStorage.login ? localStorage.login : '', //devMode ? "+77715879067" : '',
            password: localStorage.password ? localStorage.password : '', //devMode ? "Qweqwe1!" : '',
            passwordRepeat: devMode ? "Qweqwe1!" : '',
            confirm_password: '',
            wip: false,
            codeConfirmModalOpen: !false,
            signUpModalOpened: false,
            isSupplier: false,
            agreementModalOpened: false,
            passwordResetModalOpened: false,
            passwordResetCodeModalOpened: false,
            name: '',
            surname: '',
            city: '',
            cities: [],
            code: "",
            sms_code: "",
            agree: false
        };
    }
};
